class NotificationTranslationService {
    constructor(localizationService, logService) {
        this.localizationService = localizationService;
        this.log = new LogServiceWrapper(logService, 'notificationTranslationService');
    }

    translateEnablePrivateChat(msg) {
        if (msg.translation.params && msg.translation.params.hostName) {
            return this.localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.HOST_ENABLED_PRIVATE_CHAT', {
                name: msg.translation.params.hostName
            });
        } else {
            this.log.warn('customChatService', 'incorrect input param');
            return msg.message;
        }
    }

    translateDisablePrivateChat(msg) {
        if (msg.translation.params && msg.translation.params.hostName) {
            return this.localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.HOST_DISABLED_PRIVATE_CHAT', {
                name: msg.translation.params.hostName
            });
        } else {
            this.log.warn('translateEnablePrivateChat', 'incorrect input param');
            return msg.message;
        }
    }

    translateMutedUnmuted(msg, isMute, isPhoneCaller, isEveryone) {
        var updated = '';
        var translationKey = isMute
            ? 'ATTENDEE_LIST.NOTIFICATIONS.PERSON_MUTED'
            : 'ATTENDEE_LIST.NOTIFICATIONS.PERSON_UNMUTED';
        if (isPhoneCaller) {
            updated = this.localizationService.translate('COMMON.PHONE_CALLER');
        } else if (isEveryone) {
            updated = this.localizationService.translate('COMMON.EVERYONE');
        } else {
            updated = msg.translation.params.updatedAttendeeName;
        }
        return this.localizationService.translate(translationKey, {
            requester: msg.translation.params.requesterAttendeeName,
            name: updated
        });
    }

    translateLockUnlock(msg, isLock, isPhoneCaller) {
        var key = '';
        if (!isPhoneCaller) {
            if (isLock) {
                key = 'CHAT.MESSAGES.USER_LOCKED_MEETING';
            } else {
                key = 'CHAT.MESSAGES.USER_UNLOCKED_MEETING';
            }
            return this.localizationService.translate(key, { name: msg.translation.params.hostDisplayName });
        } else {
            if (isLock) {
                key = 'CHAT.MESSAGES.PHONECALLER_LOCKED_MEETING';
            } else {
                key = 'CHAT.MESSAGES.PHONECALLER_UNLOCKED_MEETING';
            }
            return this.localizationService.translate(key);
        }
    }

    translateChatCleared() {
        return this.localizationService.translate('ATTENDEE_LIST.CHAT.CLEARED');
    }

    translateNotification(msg) {
        try {
            switch (msg.translation.key) {
                case 'enable-private-chat':
                    return this.translateEnablePrivateChat(msg);
                case 'disable-private-chat':
                    return this.translateDisablePrivateChat(msg);

                case 'user-muted-all':
                    return this.translateMutedUnmuted(msg, true, false, true);
                case 'user-muted-user':
                    return this.translateMutedUnmuted(msg, true, false, false);
                case 'user-unmuted-user':
                    return this.translateMutedUnmuted(msg, false, false, false);
                case 'user-muted-phonecaller':
                    return this.translateMutedUnmuted(msg, true, true, false);
                case 'user-unmuted-phonecaller':
                    return this.translateMutedUnmuted(msg, false, true, false);

                case 'phone-caller-unlock-meeting':
                    return this.translateLockUnlock(msg, false, true);
                case 'phone-caller-lock-meeting':
                    return this.translateLockUnlock(msg, true, true);
                case 'user-lock-meeting':
                    return this.translateLockUnlock(msg, true, false);
                case 'user-unlock-meeting':
                    return this.translateLockUnlock(msg, false, false);

                case 'chat-cleared':
                    return this.translateChatCleared();
                default:
                    this.log.warn('translateNotification', 'unkonwn msg.translation.key');
                    return msg.message;
            }
        } catch (e) {
            this.log.warn('translateNotification', 'failed to translate chat message');
            return msg.message;
        }
    }
}

firebird.factory('notificationTranslationService', [
    'localizationService',
    'logService',
    (localizationService, logService) => {
        return new NotificationTranslationService(localizationService, logService);
    }
]);
